import { render } from "./Paginator.vue?vue&type=template&id=e0bd0c7a"
import script from "./Paginator.vue?vue&type=script&lang=js"
export * from "./Paginator.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./Paginator.vue?vue&type=style&index=0&id=e0bd0c7a&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script